import {buildSsoAuthorizationHeaders, getStoredSsoSessionToken} from '~/helper/ssoSession';

export default (context) => {
  return {
    httpEndpoint: process.env.VUE_APP_API_URL,
    getAuth: () => buildSsoAuthorizationHeaders(getStoredSsoSessionToken()).Authorization || '',
    inMemoryCacheOptions: {
      addTypename: false,
    },
  }
}
